import { ADD_IMAGE, RENAME_IMAGE, DELETE_IMAGE, LOAD_IMAGES } from '../constants/ActionTypes'
import { image as initialImage } from '../store/initialState'

/**
 * @typedef {import('../types/plottr').ImageRecord} ImageRecord
 * @typedef {import('../types/plottr').PlottrFileImages} Images
 */

/**
 * @typedef {ReturnType<typeof addImage> | ReturnType<typeof renameImage> | ReturnType<typeof deleteImage> | ReturnType<typeof load>} ImagesActions
 */

/**
 * @param {ImageRecord} newImage
 * @return {{ type: 'ADD_IMAGE', image: ImageRecord }}
 */
export function addImage(newImage) {
  const image = Object.assign({}, initialImage, newImage)
  return { type: ADD_IMAGE, image }
}

/**
 * @param {number} id
 * @param {String} name
 * @return {{ type: 'RENAME_IMAGE', id: number, name: String }}
 */
export function renameImage(id, name) {
  return { type: RENAME_IMAGE, id, name }
}

/**
 * @param {number} id
 * @return {{ type: 'DELETE_IMAGE', id: number }}
 */
export function deleteImage(id) {
  return { type: DELETE_IMAGE, id }
}

/**
 * @param {boolean} patching
 * @param {Images} images
 * @return {{ type: 'LOAD_IMAGES', patching: boolean, images: Images }}
 */
export function load(patching, images) {
  return { type: LOAD_IMAGES, patching, images }
}
